import { i18n } from '@/i18n'
// import store from '@/store'

export default (params) => {
  const menu = [
    {
      icon: 'config',
      name: i18n.t('impuestos.header'),
      path: 'masters/impuestos',
      use_parent_params: true,
      params_required: ['id'],
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('app.detail'),
          path: 'masters/impuestos/details',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          name: i18n.t('historical.entity_name'),
          path: 'masters/impuestos/historical',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
      ]
    }
  ]
  if (params.issuingCreation) {
    menu[0].sc = menu[0].sc.slice(0, 1)
  }
  return menu
}
